import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { Shield, Info } from 'lucide-react';
export function Privacy() {
  const {
    language
  } = useLanguage();
  const content = {
    en: {
      privacyTitle: 'Privacy-first by design',
      privacyDesc: "Your content isn't saved. CV Go App does not store your resume, job posts, or generated documents. You download what you need and keep it.",
      fairUseTitle: 'Fair use limit (reliability)',
      fairUseDesc: 'To keep the service reliable for everyone, CV Go App allows up to 5 generations per day. (1 generation = Resume + Cover Letter bundle.)'
    },
    es: {
      privacyTitle: 'Privacidad por diseño',
      privacyDesc: 'Tu contenido no se guarda. CV Go App no almacena tu CV, tus ofertas, ni los documentos generados. Tú descargas lo que necesitas y lo conservas.',
      fairUseTitle: 'Límite de uso (para estabilidad del servicio)',
      fairUseDesc: 'Para mantener el rendimiento y evitar abuso, CV Go App permite hasta 5 generaciones por día. (1 generación = paquete de CV + cover letter.)'
    }
  };
  const t = content[language];
  return <section className="py-16 bg-gray-50" data-id="element-116">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-117">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-118">
          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-119">
            <div className="flex items-center gap-3 mb-4 text-gray-900" data-id="element-120">
              <Shield className="w-6 h-6 text-green-500" data-id="element-121" />
              <h3 className="font-bold text-lg" data-id="element-122">{t.privacyTitle}</h3>
            </div>
            <p className="text-gray-600 leading-relaxed" data-id="element-123">{t.privacyDesc}</p>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100" data-id="element-124">
            <div className="flex items-center gap-3 mb-4 text-gray-900" data-id="element-125">
              <Info className="w-6 h-6 text-blue-500" data-id="element-126" />
              <h3 className="font-bold text-lg" data-id="element-127">{t.fairUseTitle}</h3>
            </div>
            <p className="text-gray-600 leading-relaxed" data-id="element-128">{t.fairUseDesc}</p>
          </div>
        </div>
      </div>
    </section>;
}